import { render, staticRenderFns } from "./onlineData.vue?vue&type=template&id=8635be2c&scoped=true&"
import script from "./onlineData.vue?vue&type=script&lang=js&"
export * from "./onlineData.vue?vue&type=script&lang=js&"
import style0 from "./onlineData.vue?vue&type=style&index=0&id=8635be2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8635be2c",
  null
  
)

export default component.exports